import Swiper, { Navigation, Pagination } from "swiper";

export const setupMedia = ($productTemplate) => {
  // Handle the product images set up

  const $productTemplateMediaContainer = $productTemplate.querySelector(
    ".product-template__media-container"
  );

  const $productMedia = $productTemplateMediaContainer.querySelectorAll(
    ".product-template__media"
  );

  const setupVideos = ($productMedia) => {
    $productMedia.forEach(($productMediaItem) => {
      if (
        $productMediaItem.classList.contains(
          "product-template__media--video"
        ) ||
        $productMediaItem.classList.contains(
          "product-template__media-swiper-slide--video"
        )
      ) {
        const $image = $productMediaItem.querySelector(".media__image");
        const $icon = $productMediaItem.querySelector(".media__icon");
        const $video = $productMediaItem.querySelector(".media__video");
        if ($image && $icon && $video) {
          $image.addEventListener("click", (event) => {
            event.preventDefault();
            $image.classList.add("hidden");
            $icon.classList.add("hidden");
            $video.classList.remove("hidden");
            $video.play();
          });
          $video.addEventListener("click", (event) => {
            event.preventDefault();
            $video.pause();
            $video.classList.add("hidden");
            $image.classList.remove("hidden");
            $icon.classList.remove("hidden");
          });
        }
      }
    });
  };

  let mediaSwiperObject = null;

  const $productMediaItems = $productTemplateMediaContainer?.querySelector(
    ".product-template__media-items"
  );
  const $itemsSwiper = $productMediaItems.querySelector(".items__swiper");
  if ($itemsSwiper) {
    const $navLeft = $itemsSwiper?.querySelector(".navigation__prev");
    const $navRight = $itemsSwiper?.querySelector(".navigation__next");

    const swiperConfig = {
      direction: "horizontal",
      speed: 1000,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 24,
    };
    if ($navLeft && $navRight) {
      swiperConfig.navigation = {
        nextEl: $navRight,
        prevEl: $navLeft,
      };
    }
    mediaSwiperObject = new Swiper($itemsSwiper, swiperConfig);
  }

  const $productMediaLinks = $productTemplateMediaContainer.querySelector(
    ".product-template__media-links"
  );
  const $linksSwiper = $productMediaLinks.querySelector(".links__swiper");
  if ($linksSwiper) {
    const swiperConfig = {
      direction: "horizontal",
      speed: 1000,
      slidesPerView: 6,
      slidesPerGroup: 1,
      spaceBetween: 8,
      breakpoints: {
        1024: {
          slidesPerView: 5,
          spaceBetween: 16,
        },
      },
    };
    const $linksSwiperSlides = $linksSwiper.querySelectorAll(".wrapper__slide");
    const linksSwiperObject = new Swiper($linksSwiper, swiperConfig);
    $linksSwiperSlides.forEach(($linksSwiperSlide) => {
      $linksSwiperSlide.addEventListener("click", (event) => {
        event.preventDefault();
        if ($itemsSwiper) {
          $itemsSwiper.swiper.slideTo(
            parseInt($linksSwiperSlide.dataset.swiperIndex)
          );
        }
      });
    });
  }

  setupVideos($productMedia);

  const $productImageSwiper = $productTemplate.querySelector(
    ".product-template__media-swiper.swiper"
  );
};

export default setupMedia;
